// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"3db6bad0","221":"88a08777","407":"4172659e","485":"142fe5a0","598":"b878f653","626":"bcf9a531","791":"8683ac8d","800":"bcf9a531","831":"0245af67"}[chunkId] + ".chunk.css";
};